import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { srConfig, email } from "@config";
import sr from "@utils/sr";
import { usePrefersReducedMotion } from "@hooks";

const FINGERPRINT = "5857 8309 32A6 3C37 3BD1 E87D 60CE E662 45C5 A4E8";
const FP_NO_SPACES = "5857830932A63C373BD1E87D60CEE66245C5A4E8";

const PUBLIC_KEY_BLOCK = `-----BEGIN PGP PUBLIC KEY BLOCK-----
Comment: 5857 8309 32A6 3C37 3BD1  E87D 60CE E662 45C5 A4E8
Comment: Hemang Sharma <admin@sharmahemang.com>
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=zLdJ
-----END PGP PUBLIC KEY BLOCK-----`;

const SOCIALS = [
  {
    name: "LinkedIn",
    handle: "linkedin.com/in/sharmahemang",
    url: "https://www.linkedin.com/in/sharmahemang/",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M6.5 9.2V18M6.5 6.2V6.3M10 18v-4.6c0-2.2 1.2-3.4 3-3.4 1.7 0 2.8 1.2 2.8 3.4V18M4.6 20h14.8A.6.6 0 0020 19.4V4.6A.6.6 0 0019.4 4H4.6a.6.6 0 00-.6.6v14.8c0 .3.3.6.6.6z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "GitHub",
    handle: "github.com/hemangsharma",
    url: "https://github.com/hemangsharma",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M9 19c-4 1.2-4-2-5-2m10 4v-3.1c0-.9.3-1.6.8-2-2.7-.3-5.6-1.3-5.6-6A4.6 4.6 0 019.5 5c-.1-.3-.5-1.6.1-3.2 0 0 1-.3 3.3 1.2a11.4 11.4 0 016 0C21.2 1.5 22.2 1.8 22.2 1.8c.6 1.6.2 2.9.1 3.2a4.6 4.6 0 011.2 3.2c0 4.7-2.9 5.7-5.6 6 .5.4.9 1.2.9 2.4V21"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const StyledContactPage = styled.main`
  width: 100%;
`;

const HeroSection = styled.section`
  max-width: 1260px;
  margin: 0 auto;
  padding: 170px clamp(28px, 6vw, 80px) 90px;

  .eyebrow {
    margin: 0 0 18px;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 13px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  h1 {
    margin: 0 0 22px;
    color: var(--text-primary);
    font-size: clamp(42px, 6vw, 82px);
    line-height: 0.98;
    letter-spacing: -0.05em;
    max-width: 820px;
  }

  .lead {
    margin: 0;
    max-width: 760px;
    color: var(--text-secondary);
    font-size: clamp(18px, 2vw, 23px);
    line-height: 1.8;
  }

  .lead strong {
    color: var(--text-primary);
    font-weight: 600;
  }
`;

const ContactShell = styled.section`
  max-width: 1260px;
  margin: 0 auto;
  padding: 0 clamp(28px, 6vw, 80px) 150px;

  .grid {
    display: grid;
    grid-template-columns: 0.92fr 1.08fr;
    gap: 20px;
    align-items: start;

    @media (max-width: 1040px) {
      grid-template-columns: 1fr;
    }
  }
`;

const MainCard = styled.div`
  padding: 30px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.42);
  border: 1px solid rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow:
    0 12px 34px rgba(0, 0, 0, 0.045),
    inset 0 1px 0 rgba(255, 255, 255, 0.36);
`;

const SideStack = styled.div`
  display: grid;
  gap: 18px;
`;

const SideCard = styled.div`
  padding: 24px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.42);
  border: 1px solid rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.35);
`;

const SectionLabel = styled.p`
  margin: 0 0 10px;
  color: var(--text-muted);
  font-family: var(--font-mono);
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

const MainTitle = styled.h2`
  margin: 0 0 14px;
  color: var(--text-primary);
  font-size: clamp(30px, 3.5vw, 42px);
  line-height: 1.08;
  letter-spacing: -0.04em;
`;

const Copy = styled.p`
  margin: 0;
  color: var(--text-secondary);
  font-size: 16px;
  line-height: 1.9;
`;

const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
`;

const PrimaryLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  padding: 0 20px;
  border-radius: 999px;
  text-decoration: none;
  font-family: var(--font-mono);
  font-size: 13px;
  transition: var(--transition);

  color: #ffffff;
  background: #111111;
  border: 1px solid #111111;

  &:hover {
    color: #ffffff;
    background: #2a2a2a;
    border-color: #2a2a2a;
    transform: translateY(-1px);
  }
`;

const SecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  padding: 0 18px;
  border-radius: 999px;
  font-family: var(--font-mono);
  font-size: 13px;
  transition: var(--transition);
  cursor: pointer;

  color: var(--text-primary);
  background: rgba(255, 255, 255, 0.62);
  border: 1px solid var(--border-light);

  &:hover {
    border-color: var(--border-medium);
    background: rgba(255, 255, 255, 0.82);
    transform: translateY(-1px);
  }
`;

const FingerprintWrap = styled.div`
  margin-top: 18px;
  display: grid;
  gap: 10px;
`;

const FingerprintLabel = styled.p`
  margin: 0;
  color: var(--text-muted);
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

const FingerprintBox = styled.div`
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.58);
  border: 1px solid var(--border-light);
  color: var(--text-primary);
  font-family: var(--font-mono);
  font-size: 13px;
  line-height: 1.8;
  word-break: break-word;
`;

const Status = styled.span`
  color: var(--text-muted);
  font-family: var(--font-mono);
  font-size: 11px;
`;

const SmallLinks = styled.div`
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const SmallLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 14px;
  border-radius: 12px;
  text-decoration: none;
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--text-primary);
  background: rgba(255, 255, 255, 0.62);
  border: 1px solid var(--border-light);
  transition: var(--transition);

  &:hover {
    color: var(--text-primary);
    border-color: var(--border-medium);
    background: rgba(255, 255, 255, 0.82);
    transform: translateY(-1px);
  }
`;

const Details = styled.details`
  margin-top: 18px;
`;

const Summary = styled.summary`
  cursor: pointer;
  list-style: none;
  user-select: none;
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--text-secondary);

  &::-webkit-details-marker {
    display: none;
  }
`;

const KeyBlock = styled.pre`
  margin-top: 12px;
  padding: 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.58);
  border: 1px solid var(--border-light);
  overflow: auto;
  max-height: 260px;
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--text-secondary);
  line-height: 1.65;
  white-space: pre;
`;

const SocialGrid = styled.div`
  display: grid;
  gap: 12px;
`;

const SocialCard = styled.a`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border-radius: 18px;
  text-decoration: none;
  color: var(--text-primary);
  background: rgba(255, 255, 255, 0.58);
  border: 1px solid var(--border-light);
  transition: var(--transition);

  &:hover {
    color: var(--text-primary);
    border-color: var(--border-medium);
    background: rgba(255, 255, 255, 0.82);
    transform: translateY(-1px);
  }
`;

const SocialIcon = styled.span`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.74);
  border: 1px solid var(--border-light);

  svg {
    width: 20px;
    height: 20px;
    display: block;
  }
`;

const SocialMeta = styled.div`
  min-width: 0;
`;

const SocialName = styled.p`
  margin: 0 0 4px;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 600;
`;

const SocialHandle = styled.p`
  margin: 0;
  color: var(--text-secondary);
  font-family: var(--font-mono);
  font-size: 12px;
  line-height: 1.6;
  word-break: break-word;
`;

const NoteList = styled.div`
  display: grid;
  gap: 12px;
`;

const NoteItem = styled.div`
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.58);
  border: 1px solid var(--border-light);

  strong {
    display: block;
    margin-bottom: 6px;
    color: var(--text-primary);
    font-size: 15px;
    font-weight: 600;
  }

  span {
    color: var(--text-secondary);
    font-size: 14px;
    line-height: 1.8;
  }
`;

const ContactPageContent = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (prefersReducedMotion || !revealContainer.current) return;
    sr.reveal(revealContainer.current, srConfig());
  }, [prefersReducedMotion]);

  const copyFingerprint = async () => {
    try {
      await navigator.clipboard.writeText(FINGERPRINT);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch (e) {
      try {
        const ta = document.createElement("textarea");
        ta.value = FINGERPRINT;
        ta.setAttribute("readonly", "");
        ta.style.position = "absolute";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 1200);
      } catch (err) {
        // ignore
      }
    }
  };

  return (
    <StyledContactPage ref={revealContainer}>
      <HeroSection>
        <p className="eyebrow">Contact</p>
        <h1>Open to meaningful work, collaboration, and conversation.</h1>
        <p className="lead">
          Whether it is a role, project, technical discussion, or secure communication,
          feel free to reach out. I am most interested in work around <strong>software,
          analytics, data systems, machine learning, and AI</strong>.
        </p>
      </HeroSection>

      <ContactShell>
        <div className="grid">
          <MainCard>
            <SectionLabel>Primary Contact</SectionLabel>
            <MainTitle>Best reached by email.</MainTitle>
            <Copy>
              I keep communication simple. If you would like to discuss an opportunity,
              ask a question, or start a conversation, email is the best place to begin.
            </Copy>

            <ActionRow>
              <PrimaryLink href={`mailto:${email}`}>Email me</PrimaryLink>
              <SecondaryButton type="button" onClick={copyFingerprint}>
                Copy PGP fingerprint
              </SecondaryButton>
              {copied && <Status>Copied</Status>}
            </ActionRow>

            <FingerprintWrap>
              <FingerprintLabel>PGP Fingerprint</FingerprintLabel>
              <FingerprintBox>
                <code>{FINGERPRINT}</code>
              </FingerprintBox>
            </FingerprintWrap>

            <SmallLinks>
              <SmallLink
                href={`https://keys.openpgp.org/vks/v1/by-fingerprint/${FP_NO_SPACES}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Download key
              </SmallLink>

              <SmallLink
                href={`https://keys.openpgp.org/search?q=${FP_NO_SPACES}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Search key
              </SmallLink>
            </SmallLinks>

            <Details>
              <Summary>Show public key block</Summary>
              <KeyBlock>{PUBLIC_KEY_BLOCK}</KeyBlock>
            </Details>
          </MainCard>

          <SideStack>
            <SideCard>
              <SectionLabel>Social</SectionLabel>
              <SocialGrid>
                {SOCIALS.map(social => (
                  <SocialCard
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <SocialIcon aria-hidden="true">{social.icon}</SocialIcon>

                    <SocialMeta>
                      <SocialName>{social.name}</SocialName>
                      <SocialHandle>{social.handle}</SocialHandle>
                    </SocialMeta>
                  </SocialCard>
                ))}
              </SocialGrid>
            </SideCard>
          </SideStack>
        </div>
      </ContactShell>
    </StyledContactPage>
  );
};

export default ContactPageContent;